import cloneDeep from 'lodash/cloneDeep'
import { randomId } from 'heliocor-ui'

import {
    ACTIVATE_CAFE,
    ACTIVATE_CUSTOM_NAVIGATION,
    DELETE_ALL_CURRENT_DOCS,
    DELETE_CURRENT_OWNER_DOC,
    DELETE_ENTITY,
    DELETE_FILES_FROM_CURRENT_OWNER_DOC,
    DELETE_LOOKUP_SUGGESTION,
    DELETE_STORED_DOCUMENT,
    RESET_ACTIVATION,
    SET_BACKUP_PARTY,
    SET_CAFE_STATUS,
    SET_CLIENT_EMAIL,
    SET_COMPANY_LOOKUP_STRUCTURE,
    SET_CP_FIELDS,
    SET_CURRENT_OWNER_DOC,
    SET_CURRENT_OWNER_DOCS,
    SET_CUSTOM_FIELDS,
    SET_DOCUMENT_RETRIES,
    SET_INIT_APP,
    SET_IS_REQUEST,
    SET_NAVIGATION,
    SET_NOTIFICATION,
    SET_ONBOARDING_TYPE,
    SET_OWNERS,
    SET_OWNERS_WARNING_MIN_DOC,
    SET_PHASE_TYPE,
    SET_SETTINGS,
    SET_STEPS_LIST,
    SET_STEP_HAS_ERROR,
    SET_STEP_INDEX,
    SET_SUPPORTED_COUNTRIES,
    SET_SUPPORTED_REGIONS,
    SET_TERMS_ACCEPTANCE,
    SET_TOKEN_VERIFICATION,
    STORE_DOCUMENT,
    STORE_DOCUMENTS,
    SET_POST_ERRORS,
    STORE_OWNER,
    STORE_PARTY_DATA,
    UPDATE_OWNERS,
    DELETE_POST_ERROR,
    SET_FIELD_CATEGORIES,
    SET_CP_CATEGORIES,
    SET_CURRENT_OWNER_CATEGORY_REQUEST
} from './actionTypes'

const initialState = {
    config: {
        authenticated: null,
        activationDataChecked: false,
        language: 'en-EN',
        token: undefined,
        termsAccepted: false,
        partyType: 'VERIFICATION'
    },
    general: {
        notification: null,
        appIsReady: false,
        appStatus: {}
    },
    navigation: {
        stepIndex: 0,
        stepsList: [],
        completedSteps: []
    },
    settings: {
        customLogo: undefined,
        customFields: {},
        formattingOptions: {},
        colors: {}
    },
    party: {
        data: {},
        documents: [],
        connectedParties: [],
        docValidations: {},
        maxRetries: 1
    },
    currentOwnerDocs: [],
    currentOwnerDocsToDelete: []
}


function cafe(state = { ...initialState }, action) {

    let connectedPersons

    switch (action.type) {

        case ACTIVATE_CAFE:
            return {
                ...state,
                config: {
                    ...state.config,
                    authenticated: action.authenticated
                }
            }

        case ACTIVATE_CUSTOM_NAVIGATION:
            return {
                ...state,
                navigation: {
                    ...state.navigation,
                    customNavigationEnabled: action.enabled
                }
            }

        case DELETE_ENTITY:
            return {
                ...state,
                party: {
                    ...state.party,
                    connectedParties: state.party.connectedParties.filter(cp => cp.identifier !== action.identifier)
                }
            }

        case DELETE_LOOKUP_SUGGESTION:
            let lookupStructureData = cloneDeep(state.party.lookupStructureData)
            let indexOfPerson = lookupStructureData.findIndex(person => person.identifier === action.owner.identifier)
            lookupStructureData.splice(indexOfPerson, 1)

            return {
                ...state,
                party: {
                    ...state.party,
                    lookupStructureData
                }
            }

        case DELETE_STORED_DOCUMENT:

            let docUpdated = cloneDeep(state.party.documents)
            let docToRemove = docUpdated.findIndex(doc => doc.type === action.document)
            docUpdated.splice(docToRemove, 1)

            return {
                ...state,
                party: {
                    ...state.party,
                    documents: docUpdated
                }
            }

        case RESET_ACTIVATION:
            return {
                ...initialState,
                config: {
                    ...initialState.config,
                    authenticated: false,
                    phase: state.config.phase,
                    org: state.config.org
                },
                settings: state.settings,
                general: {
                    ...initialState.general,
                    appIsReady: true
                }
            }

        case SET_CAFE_STATUS:
            return {
                ...state,
                general: {
                    ...state.general,
                    cafeStatus: action.cafeStatus
                }
            }

        case SET_INIT_APP:
            return {
                ...state,
                general: {
                    ...state.general,
                    appIsReady: action.appIsReady
                }
            }

        case SET_CLIENT_EMAIL:
            return {
                ...state,
                config: {
                    ...state.config,
                    email: action.email
                }
            }

        case SET_BACKUP_PARTY:
            return {
                ...state,
                party: {...state.party, ...action.party},
                navigation: {...state.navigation, ...action.navigation}
            }

        case SET_CUSTOM_FIELDS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    customFields: action.customFields
                },
                general: {
                    ...state.general,
                    appStatus: {
                        ...state.general.appStatus,
                        fields: 'LOADED'
                    }
                }
            }

        case SET_CP_FIELDS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    cpFields: action.fields
                }
            }

        case SET_CP_CATEGORIES:
                return {
                    ...state,
                    settings: {
                        ...state.settings,
                        cpCategories: action.categories
                    }
                }
            
        case SET_SUPPORTED_COUNTRIES:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    supportedCountries: action.supportedCountries
                }
            }
        
        case SET_SUPPORTED_REGIONS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    supportedRegions: action.supportedRegions
                }
            }

        case STORE_DOCUMENTS:
            return {
                ...state,
                party: {
                    ...state.party,
                    documents: [...action.docs]
                }
            }

        case SET_COMPANY_LOOKUP_STRUCTURE:
            return {
                ...state,
                party: {
                    ...state.party,
                    lookupStructureData: action.structureData.map(item => ({ ...item, identifier: randomId() }))
                }
            }

        case SET_DOCUMENT_RETRIES:

            return {
                ...state,
                party: {
                    ...state.party,
                    docValidations: action.docValidations
                }
            }

        case SET_ONBOARDING_TYPE:
            return {
                ...state,
                config: {
                    ...state.config,
                    partyType: action.partyType
                }
            }

        case SET_NOTIFICATION:
            return {
                ...state,
                general: {
                    ...state.general,
                    notification: action.notification
                }
            }

        case SET_SETTINGS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    ...action.settings,
                    kycType: action.settings.kycType !== undefined ? action.settings.kycType : state.settings.kycType
                },
                party: {
                    ...state.party,
                    maxRetries: action.retries === undefined ? state.party.maxRetries : Number(action.retries)
                }
            }

        case SET_STEP_INDEX:

            const completedSteps = [...state.navigation.completedSteps]

            if (!isNaN(action.completedStep)) completedSteps.push(action.completedStep)

            return {
                ...state,
                navigation: {
                    ...state.navigation,
                    stepIndex: action.stepIndex,
                    completedSteps: [...new Set(completedSteps)]
                }
            }

        case SET_STEP_HAS_ERROR:
            return {
                ...state,
                navigation: {
                    ...state.navigation,
                    completedSteps: [...state.navigation.completedSteps].filter(step => step !== action.stepIndex)
                }
            }

        case SET_TERMS_ACCEPTANCE:
            return {
                ...state,
                config: {
                    ...state.config,
                    termsAccepted: action.accepted
                }
            }

        case SET_OWNERS_WARNING_MIN_DOC:
            connectedPersons = cloneDeep(state.party.connectedParties.connectedPersons)
            connectedPersons.forEach(owner => {
                if (action.identifiers.includes(owner.identifier)) owner.minDocsNotReached = true
            })

            return {
                ...state,
                party: {
                    ...state.party,
                    connectedParties: {
                        ...state.party.connectedParties,
                        connectedPersons: connectedPersons
                    }
                }
            }

        case SET_TOKEN_VERIFICATION:
            return {
                ...state,
                config: {
                    ...state.config,
                    activationDataChecked: action.activationDataChecked,
                    token: action.token
                }
            }

        case STORE_DOCUMENT:
            return {
                ...state,
                party: {
                    ...state.party,
                    documents: [
                        ...state.party.documents,
                        action.document
                    ]
                }
            }

        case STORE_PARTY_DATA:
            delete action.party.data.lookup
            return {
                ...state,
                party: {
                    ...state.party,
                    data: action.party.data,
                    backupPartyLoaded: action.party.backupPartyLoaded
                }
            }

        case STORE_OWNER:
            const { owner } = action

            const parentIndex = state.party.connectedParties.findIndex(cp => cp.identifier === owner.parentId)

            const olderSiblingIndex = state.party.connectedParties.findLastIndex(cp => cp.parentId === owner.parentId)

            const index = (olderSiblingIndex === -1 ? parentIndex : olderSiblingIndex) + 1

            return {
                ...state,
                party: {
                    ...state.party,
                    connectedParties: [
                        ...state.party.connectedParties.slice(0, index),
                        action.owner,
                        ...state.party.connectedParties.slice(index)
                    ]
                }
            }

        case UPDATE_OWNERS:
            return {
                ...state,
                party: {
                    ...state.party,
                    connectedParties: state.party.connectedParties.map(cp =>
                        cp.identifier === action.entity.identifier
                            ? action.entity
                            : cp
                    )
                }
            }

        case SET_STEPS_LIST:

            return {
                ...state,
                navigation: {
                    ...state.navigation,
                    stepsList: action.stepsList
                }
            }

        case SET_PHASE_TYPE:

            return {
                ...state,
                config: {
                    ...state.config,
                    phase: action.phase,
                    org: action.org
                }
            }

        case SET_IS_REQUEST:
            return {
                ...state,
                config: {
                    ...state.config,
                    isRequest: action.isRequest
                }
            }

        case SET_OWNERS:
            return {
                ...state,
                party: {
                    ...state.party,
                    connectedParties: action.owners
            }
        }

        case SET_CURRENT_OWNER_CATEGORY_REQUEST: {
            const ownerDocs = cloneDeep(state.currentOwnerDocs) || []
            const nonCategoryRelatedDocs = ownerDocs.filter(doc => doc.category !== action.documentCategory)
            let newOwnerDocs = [...nonCategoryRelatedDocs]

            action.documents.forEach(doc => {
                newOwnerDocs.push({ category: action.documentCategory, type: doc.name, request: true })
            })

            return {...state, currentOwnerDocs: newOwnerDocs}
        }

        case SET_CURRENT_OWNER_DOC: {
            const ownerDocs = cloneDeep(state.currentOwnerDocs)
            let uploadedDoc = ownerDocs.find(doc => doc.type === action.docType)
            const uploadedDocIndex = ownerDocs.findIndex(doc => doc.type === action.docType)
            if (action.doc) {
                if (uploadedDoc) {
                    ownerDocs.splice(uploadedDocIndex, 1, action.doc)
                    return {
                        ...state,
                        currentOwnerDocs: ownerDocs
                    }
                } else {
                    return {
                        ...state,
                        currentOwnerDocs: [
                            ...state.currentOwnerDocs,
                            action.doc
                        ],
                        currentOwnerDocsToDelete: state.currentOwnerDocsToDelete.filter(doc => doc.type !== action.doc.type),
                    }
                }
            } else {
                let dataIndex = 0
                if (uploadedDoc) {
                    uploadedDoc.datas && uploadedDoc.datas.forEach(d => {
                        if (d.index > dataIndex) dataIndex = d.index
                    })
                    uploadedDoc = {
                        ...uploadedDoc,
                        datas: [...uploadedDoc.datas || [], { content: action.url, index: dataIndex + 1, fileName: `${action.docType} ${dataIndex + 1}` }]
                    }
                    ownerDocs.splice(uploadedDocIndex, 1, uploadedDoc)
                    return {
                        ...state,
                        currentOwnerDocs: ownerDocs
                    }
                } else {
                    ownerDocs.push({ category: action.category, type: action.docType, datas: [{ content: action.url, index: dataIndex + 1, fileName: `${action.docType} ${dataIndex + 1}` }] })
                    return {
                        ...state,
                        currentOwnerDocs: ownerDocs,
                        currentOwnerDocsToDelete: state.currentOwnerDocsToDelete.filter(doc => doc.type !== action.docType),
                    }
                }
            }
        }

        case SET_CURRENT_OWNER_DOCS:
            const docIds = (action.docs && action.docs.map(doc => doc.type)) || []
            return {
                ...state,
                currentOwnerDocs: action.docs,
                currentOwnerDocsToDelete: state.currentOwnerDocsToDelete.filter(doc => !docIds.includes(doc.type))
            }

        case DELETE_CURRENT_OWNER_DOC: {
            const ownerDocs = cloneDeep(state.currentOwnerDocs)
            const docToDelete = ownerDocs.find(doc => doc.type === action.docType)
            const docIndexToDelete = ownerDocs.findIndex(doc => doc.type === action.docType)
            ownerDocs.splice(docIndexToDelete, 1)
            return {
                ...state,
                currentOwnerDocs: ownerDocs,
                currentOwnerDocsToDelete: [...state.currentOwnerDocsToDelete, docToDelete]
            }
        }

        case DELETE_FILES_FROM_CURRENT_OWNER_DOC: {
            const ownerDocs = cloneDeep(state.currentOwnerDocs)
            const docToDelete = ownerDocs.find(doc => doc.type === action.docType)
            const docIndexToDelete = ownerDocs.findIndex(doc => doc.type === action.docType)

            if (docToDelete.datas && docToDelete.datas.length === 1) {
                ownerDocs.splice(docIndexToDelete, 1)
                return {
                    ...state,
                    currentOwnerDocs: ownerDocs,
                    currentOwnerDocsToDelete: [...state.currentOwnerDocsToDelete, docToDelete]
                }
            } else {
                const dataIndex = ownerDocs[docIndexToDelete].datas.findIndex(data => data.index === action.index)
                ownerDocs[docIndexToDelete].datas.splice(dataIndex, 1)
                return {
                    ...state,
                    currentOwnerDocs: ownerDocs
                }
            }
        }

        case DELETE_ALL_CURRENT_DOCS:
            return {
                ...state,
                currentOwnerDocs: [],
                currentOwnerDocsToDelete: []
            }

        case SET_NAVIGATION:
            return {
                ...state,
                navigation: action.navigation
            }
        
        case SET_FIELD_CATEGORIES:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    fieldCategories: action.fieldCategories
                }
            }
        
        case SET_POST_ERRORS:
            return {
                ...state,
                party: {
                    ...state.party,
                    postErrors: action.errors
                }
            }
        
        case DELETE_POST_ERROR:
            return  {
                ...state,
                party: {
                    ...state.party,
                    postErrors: state.party.postErrors.filter(e => action.identifier
                        ? (e.field !== action.fieldId) || (e.identifier !== action.identifier)
                        : (e.field !== action.fieldId) || !!e.identifier
                    )
                }
            }

        default:
            return state
    }
}

export default cafe

